import React, { Component } from "react";
import { connect } from "react-redux";
import { API_URL } from "../../config";
// import AddCircleOutlineOutlinedIcon from "@material-ui/icons/AddCircleOutlineOutlined";
// import CampaignTablesComponent from "./CampaignTables";

import {
  routeConfig,
  routeAdmin,
  routeCustomer,
  routeCampaign,
  DashboardPath,
  DashboardPath2
} from "../SideBar/RouteContent";
import MediaCard from "../Card/Card1";
import MediaCard2 from "../Card/Card2";

import "./Home.css";
import { lenghtCount } from "../../Queries";
import { fetchMethod } from "../../FetchMethod";
import { SemipolarLoading } from "react-loadingg";
// import { Button, Drawer } from "@material-ui/core";

// import AddCampaign from ".././Form/AddNewForm";
// import {
//   addCampaignForm,
//   campaignValidation
// } from "./../Campaign/CampaignConfig";

import {
  getCampaignCustomers,
  getcampaignmanager,
  // addNewCampaign,
  // saveCampaignstep,
  getcampaignmanagerassignto,
  // EditCampaignQuery
} from "./../Campaign/campaignQueries";
class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      DashboardlistData: [],
      totalCounts: "",
      totalCount: "",
      header: "Home",
      loading: false,
      routeconfig: [],
      routeconfig2: [],
      openForm: false,
      DashboardData2: {
        TotalCampaign: 0,
        LiveCompaign: 0,
        TotalConnectRate: "",
        LiveConnectRate: "",
        TotalEngaged: "",
        LiveEngaged: "",
        TotalLeads: "",
        LiveLeads: "",
        newRecentdata: ""
      },
      hiddenRoute: [
        {
          title: "Users"
        },
        {
          title: "Customers"
        },
        {
          title: "ABM"
        },
        {
          title: "Monitoring"
        },
        {
          title: "Leads"
        },
        {
          title: "Campaigns"
        }
      ],
      hiddenRoute2: [
        {
          title: "Users"
        }
      ]
    };
  }

  getDashboardData2 = () => {
    var dasId = 0;
    if (localStorage.getItem("role") === "CUSTOMER") {
      dasId = localStorage.getItem("customer");
    } else {
      dasId = localStorage.getItem("id");
    }

    fetch(
      `${API_URL}/api/Campaigns/getHomeDas?role=${localStorage.getItem(
        "role"
      )}&userid=${dasId}&access_token=${localStorage.getItem("token")}`,
      {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-type": "application/json"
        }
      }
    )
      .then(res => res.json())

      .then(res => {
        this.setState(
          {
            DashboardlistData2: res.response
          },
          () => {
            this.setDataCalculation2();
          }
        );
      })
      .catch(e => {
        console.log(e);
      });
  };
  setDataCalculation2 = () => {
    const { DashboardlistData2, DashboardData2 } = this.state;

    var engData = "0";
    var leadData = "0";
    var connectData = "0";


    if (DashboardlistData2[3].engagedRate !== undefined && DashboardlistData2[3].engagedRate !== null ) {

      engData = DashboardlistData2[3].engagedRate.toFixed(0);
    }
    if (DashboardlistData2[4].leadsRate != null) {
      leadData = DashboardlistData2[4].leadsRate.toFixed(0);
    }
    if (DashboardlistData2[2].connectRate != null) {
      connectData = DashboardlistData2[2].connectRate.toFixed(0);
    }
    DashboardData2.TotalCampaign = DashboardlistData2[1].TotalCompaigns;
    DashboardData2.LiveCompaign = DashboardlistData2[0].LiveCompaigns;
    DashboardData2.TotalEngaged = engData;
    DashboardData2.TotalLeads = leadData;
    DashboardData2.TotalConnectRate = connectData;
    DashboardData2.newRecentdata = DashboardlistData2[5];

    this.setState({
      DashboardlistData2,
      loading: false
    });
  };

  componentDidMount() {
    localStorage.setItem("path", "/");
    let routeconfig = [];
    let routeconfig2 = [];

    if (localStorage.getItem("role") === "SADMIN") {
      for (let i = 0; i < routeConfig.length - 2; i++) {
        routeconfig[i] = routeConfig[i + 1];
        routeconfig2[i] = routeConfig[0];
      }
    }
    if (localStorage.getItem("role") === "ADMIN") {
      for (let i = 0; i < routeAdmin.length - 1; i++) {
        routeconfig[i] = routeAdmin[i + 1];
        routeconfig2[i] = routeConfig[0];
      }
    }
    if (localStorage.getItem("role") === "CUSTOMER") {
      for (let i = 0; i < routeCustomer.length - 1; i++) {
        routeconfig[i] = routeCustomer[i + 1];
        routeconfig2[i] = routeConfig[0];
      }
    }
    if (localStorage.getItem("role") === "CAMPAIGNMANAGER") {
      for (let i = 0; i < routeCampaign.length - 1; i++) {
        routeconfig[i] = routeCampaign[i + 1];
        routeconfig2[i] = routeConfig[0];
      }
    }
    const { hiddenRoute, hiddenRoute2 } = this.state;

    var route = routeconfig.filter(function(x) {
      return !hiddenRoute.reduce(function(y, z) {
        return x.title === y.title || x.title === z.title || y === true;
      });
    });
    var route2 = routeconfig2.filter(function(x) {
      return !hiddenRoute2.reduce(function(y, z) {
        return x.title === y.title || x.title === z.title || y === true;
      });
    });

    route2.push(...DashboardPath2);
    this.setState({
      routeconfig2: route2
    });
    route.push(...DashboardPath);
    this.setState({
      routeconfig: route
    });

    this.fetchData();
    this.getDashboardData2();
    this.props.onHandleCampaign();
    this.props.onHandleSidebarText("/");

    const filter1 =
      localStorage.getItem("role") === "ADMIN"
        ? {
            where: {
              active: 1,
              createdby: localStorage.getItem("id"),
              order: "company asc"
            }
          }
        : { where: { active: 1, order: "company asc" } };
    fetchMethod(getCampaignCustomers, filter1)
      .then(res => res.json())
      .then(res => {
        this.setState({ custdata: res.data.allCustomers.Customers }, () => {});
      })
      .catch(e => console.log(e));

    const filter2 =
      localStorage.getItem("role") === "ADMIN"
        ? {
            where: {
              order: "company asc",
              createdby: localStorage.getItem("id")
            }
          }
        : { where: { order: "company asc" } };
    fetchMethod(getCampaignCustomers, filter2)
      .then(res => res.json())
      .then(res => {
        this.setState({ custdata1: res.data.allCustomers.Customers }, () => {});
      })
      .catch(e => console.log(e));

    const filter =
      localStorage.getItem("role") === "ADMIN"
        ? {
            where: {
              createdby: localStorage.getItem("id"),
              role: "CAMPAIGNMANAGER",
              status: 1,
              order: "firstName asc"
            }
          }
        : {
            where: {
              role: "CAMPAIGNMANAGER",
              status: 1,
              order: "firstName asc"
            }
          };

    fetchMethod(getcampaignmanager, filter)
      .then(res => res.json())
      .then(res => {
        let data =
          res.data.allUsersdata !== undefined && res.data.allUsersdata !== null
            ? res.data.allUsersdata.Usersdata
            : "";

        this.setState({ campmanager: data }, () => {});
      })
      .catch(e => console.log(e));

    const filter3 =
      localStorage.getItem("role") === "ADMIN"
        ? {
            where: {
              createdby: localStorage.getItem("id"),
              role: "CAMPAIGNMANAGER",
              order: "firstName asc"
            }
          }
        : {
            where: {
              role: "CAMPAIGNMANAGER",
              order: "firstName asc"
            }
          };

    fetchMethod(getcampaignmanager, filter3)
      .then(res => res.json())
      .then(res => {
        let data =
          res.data.allUsersdata !== undefined && res.data.allUsersdata !== null
            ? res.data.allUsersdata.Usersdata
            : "";

        this.setState({ campmanager1: data }, () => {});
      })
      .catch(e => console.log(e));

    fetchMethod(getcampaignmanagerassignto)
      .then(res => res.json())
      .then(res => {
        this.setState({ assignTo: res.data.allUsersdata.Usersdata }, () => {});
      })
      .catch(e => console.log(e));

  }

  toggleDrawer = (side, open) => event => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    this.props.OnClear(this.state.clear);
    this.setState({ ...this.state, [side]: open });
  };

  fetchData = () => {
    this.setState({ loading: true }, () => {
      const filter = {
        where: {
          active: "1",
          contactstatus: {
            nlike: "%noop%",
            options: "i"
          }
        }
      };
      fetchMethod(lenghtCount, filter)
        .then(response => {
          return response.json();
        })

        .catch(e => {
          console.log(e);
          this.setState({ loading: true });
        });
    });
  };

  onClickCard = headerText => {
    this.props.onHandleSidebarText("/");
  };

  render() {
    if (this.state.loading) {
      return (
        <div className="spinner">
          <SemipolarLoading size={50} color={"#004379"} />
        </div>
      );
    }

    var today = new Date();
    var curHr = today.getHours();

    var currentTime = "";
    if (curHr < 12) {
      currentTime = "Good morning";
    } else if (curHr < 16) {
      currentTime = "Good afternoon";
    } else {
      currentTime = "Good evening";
    }

    return (
      <div className="homePageSection">
        <div className="gridContainer">
          <div className="greetFlexBox">
            <div className="greetDataBox">
              <h4 className="greetHead">
                <span>{currentTime}</span>,
                <span className="name"> {localStorage.getItem("name")}</span>!
              </h4>
              <p>Here’s what’s happening with your LinkedIn campaigns today</p>
            </div>
          </div>

          <div className="statusDataFlexBox">
            {this.state.routeconfig.map(cards => {
              return (
                <div className="gridItem" key={cards.title}>
                  <MediaCard
                    header={cards.title}
                    onClickCard={this.onClickCard}
                    currentHeader={cards.pageHeader}
                    headerPath={cards.path}
                    DashboardData={this.state.DashboardData2}
                  />
                </div>
              );
            })}
          </div>

          <div className="campaignPerform-sec">
            <h2 className="title">Live Campaign Performance</h2>

            <div className="campaignPerformFlexBox">
              <div className="campaign_left">
                <div>
                  <div>
                    {this.state.routeconfig2.map(cards => {
                      return (
                        <div>
                          <MediaCard2
                            header={cards.title}
                            onClickCard={this.onClickCard}
                            currentHeader={cards.pageHeader}
                            headerPath={cards.path}
                            DashboardData={this.state.DashboardData2}
                          />
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onHandleSidebarText: data =>
      dispatch({
        type: "HANDLE_SIDEBAR_TEXT",
        payload: data
      }),
    onHandleCampaign: data =>
      dispatch({ type: "Campaign_Detail", payload: null })
  };
};

const mapStateToProps = state => {
  return {
    header: state.Header
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(HomePage);
